import { TWO_FACTOR_CODE_LENGTH } from '../../domain/two-factor';
import { TwoFAResult } from '../../services/two-factor.service';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { Validators } from '@angular/forms';
import type { I18nService } from '@ppl/i18n';
import type { TControlsConfig } from '@ppl/ui/form';
import { FormValueControl, getFormControlProvider } from '@ppl/utils/form.utils';
import { PplValidators } from '@ppl/utils/validators.utils';

@Component({
    selector: 'ppl-two-factor-method-setup-verify',
    templateUrl: './two-factor-method-setup-verify.component.html',
    styleUrls: ['./two-factor-method-setup-verify.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        getFormControlProvider(() => TwoFactorMethodSetupVerifyComponent)
    ],
    standalone: false
})
@FormValueControl()
export class TwoFactorMethodSetupVerifyComponent {

  @Input() value: string;
  @Input() sentTo: string;
  @Input() title?: string;
  @Input() description?: string;
  @Input() showResendCode = true;

  @Output() valueChange = new EventEmitter<string>();
  @Output() resendCode = new EventEmitter();

  TWO_FACTOR_CODE_LENGTH = TWO_FACTOR_CODE_LENGTH;

  static getFormControlConfig(): TControlsConfig<TwoFactorMethodSetupVerifyFormData> {
    return {
      code: [
        '',
        [
          Validators.required,
          PplValidators.integer,
          Validators.minLength(TWO_FACTOR_CODE_LENGTH),
          Validators.maxLength(TWO_FACTOR_CODE_LENGTH)
        ]
      ]
    };
  }

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) { }
}

interface TwoFactorMethodSetupVerifyFormData {
  code: string;
}

export function getVerificationErrorMessage(i18nService: I18nService, result: TwoFAResult) {
  switch (result) {
    case TwoFAResult.EXPIRED:
      return i18nService.translate('Verification_code_expired');
    case TwoFAResult.FAILED:
      return i18nService.translate('Invalid_verification_code');
    default:
      return null;
  }
}
